module.exports = __webpack_public_path__ + "static/media/israel_urmeer_2.e0f041ca.jpg";